import { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { label } from "../../../../config";
import { filterData } from "../../../../utils/kendo";

/**
 * common Dropdown for user profile for variables in admin console
 * @param {*} param
 * @author {Prachi Jain}
 */
const RightProfileDropdown = ({ dropdownData, dropdownValue, title, keyName, disabled, handleChange }) => {
  const [filteredDropdownList, setFilteredDropdownList] = useState([]);
  const [finalValue, setFinalValue] = useState({});

  /**
   * set final value as select if we dont have any value
   */
  useEffect(() => {
    setFilteredDropdownList([...dropdownData]);
    setFinalValue(dropdownValue || { label: label.SELECT });
  }, [dropdownData, dropdownValue]);

  const handleFilterChange = (event) => {
    const filteredList = filterData(event.filter, dropdownData);
    setFilteredDropdownList([...filteredList]);
  };

  const handleOnChange = (event) => {
    setFinalValue(event.value);
    handleChange(event);
  };

  return (
    <>
      <div className='form-group'>
        <label className='mb-0'>{title}</label>
        <DropDownList
          className='w-100'
          name={keyName}
          data={filteredDropdownList}
          value={finalValue}
          textField='label'
          dataItemKey='value'
          disabled={disabled}
          onChange={handleOnChange}
          filterable={true}
          onFilterChange={handleFilterChange}
          id={`rightprofilepanel-${keyName}`}
        />
      </div>
    </>
  );
};

export default RightProfileDropdown;
